'use client'

import { useEffect, useState } from 'react'
import {
  NEXT_PUBLIC_ANDROID_STORE_URL,
  NEXT_PUBLIC_APP_SCHEME,
  NEXT_PUBLIC_IOS_STORE_URL,
  NEXT_PUBLIC_PRODUCT_PAGE_URL,
} from '@/configs/env'
import QRCode from 'react-qr-code'

export default function DownloadAppPage() {
  const [qrValue, setQrValue] = useState(NEXT_PUBLIC_PRODUCT_PAGE_URL + '/tai-app')
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    if (typeof window !== 'undefined') {
      setQrValue(window.location.href)
    }

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    const isAndroid = /Android/i.test(navigator.userAgent)
    const scheme = NEXT_PUBLIC_APP_SCHEME
    const iosStore = NEXT_PUBLIC_IOS_STORE_URL
    const androidStore = NEXT_PUBLIC_ANDROID_STORE_URL

    const handleDeepLink = (storeUrl: string) => {
      // Gọi scheme để mở app
      window.location.href = scheme

      const visibilityChangeHandler = () => {
        if (document.hidden || document.visibilityState === 'hidden') {
          clearTimeout(timeoutId)
          window.removeEventListener('visibilitychange', visibilityChangeHandler)
        }
      }

      window.addEventListener('visibilitychange', visibilityChangeHandler)

      const timeoutId = setTimeout(() => {
        window.removeEventListener('visibilitychange', visibilityChangeHandler)
        window.location.href = storeUrl
      }, 2500)
    }

    if (isIOS) {
      handleDeepLink(iosStore)
      return
    }

    if (isAndroid) {
      handleDeepLink(androidStore)
      return
    }
  }, [])

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] py-12 px-4 bg-gray-50">
      <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl max-w-xl w-full text-center border border-gray-100">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Tải Ứng Dụng BuyXShare</h1>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          Trải nghiệm mua sắm tuyệt vời hơn trên ứng dụng di động. Quét mã QR hoặc chọn hệ điều hành của bạn để tải.
        </p>

        {/* QR Code Section */}
        <div className="flex justify-center mb-8">
          <div className="relative border-2 border-blue-100 p-4 rounded-xl bg-white shadow-sm inline-block">
            {isMounted ? (
              <QRCode value={qrValue} size={160} level="H" />
            ) : (
              <div style={{ width: 160, height: 160 }} />
            )}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-1.5 rounded-lg font-bold text-blue-600 text-[14px] leading-none shadow-sm">
              BXS
            </div>
          </div>
        </div>

        <p className="text-sm font-medium text-blue-600 mb-6 uppercase tracking-wider">Hoặc tải trực tiếp</p>

        {/* Buttons Section */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={NEXT_PUBLIC_IOS_STORE_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center gap-3 bg-blue-600 text-white px-6 py-3.5 rounded-lg font-semibold hover:bg-blue-700 transition-all shadow-md hover:shadow-lg w-full sm:w-auto"
          >
            <svg viewBox="0 0 384 512" fill="currentColor" className="w-5 h-5">
              <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
            </svg>
            App Store
          </a>
          <a
            href={NEXT_PUBLIC_ANDROID_STORE_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center gap-3 bg-blue-600 text-white px-6 py-3.5 rounded-lg font-semibold hover:bg-blue-700 transition-all shadow-md hover:shadow-lg w-full sm:w-auto"
          >
            <svg viewBox="0 0 512 512" fill="currentColor" className="w-5 h-5">
              <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z" />
            </svg>
            Google Play
          </a>
        </div>
      </div>
    </div>
  )
}
